import { useEffect, useState } from "react"
import { DateTime } from "luxon"

export const DOT_SIZE = 5

export const getCurrentTimeRangeState = (currentTime: DateTime, startHour: number, endHour: number) => {
  const wraps = endHour < startHour
  const normalizedEndHour = wraps ? endHour + 24 : endHour
  const normalizedCurrentHour = wraps && currentTime.hour < startHour ? currentTime.hour + 24 : currentTime.hour

  return {
    hourDiff: normalizedCurrentHour - startHour,
    inRange: normalizedCurrentHour >= startHour && normalizedCurrentHour < normalizedEndHour,
  }
}

export const useCurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(DateTime.now())

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(DateTime.now())
    }, 30000)

    return () => clearInterval(interval)
  }, [])

  return currentTime
}
